<template>
  <div class="card relative flex flex-col items-center bg-tertiary p-4">
    <p v-if="cardData?.description" class="chip mb-2 max-w-full truncate text-center">
      {{ cardData?.description }}
    </p>

    <div class="flex flex-wrap items-center justify-center gap-2">
      <p
        v-if="cardData?.size"
        class="inline-flex h-8 max-w-[150px] items-center truncate rounded-full border border-gray-300 px-3 py-1 text-sm font-medium"
      >
        {{ cardData?.size }}
      </p>

      <p
        v-if="cardData?.productUnitCode"
        class="inline-flex h-8 max-w-[150px] items-center truncate rounded-full border border-gray-300 px-3 py-1 text-sm font-medium"
      >
        {{ cardData?.productUnitCode }}
      </p>
      <div
        v-if="cardData?.primaryColorHex"
        class="inline-flex h-6 w-6 items-center rounded-full border border-gray-300"
        :style="{ backgroundColor: cardData?.primaryColorHex }"
      ></div>
    </div>

    <!-- Data Loading Information -->
    <div class="my-4 text-center">
      <p class="select-none text-muted">Carregamento de dados</p>
      <p class="text-sm text-muted">{{ formattedDate }}</p>
    </div>

    <!-- Indicators -->
    <div v-if="showIndicators" class="flex w-full flex-row gap-2">
      <SimpleMetric
        v-for="indicator in indicators"
        class="flex-grow text-white"
        :key="indicator.title"
        :class="indicator.class"
        :title="indicator.title"
        :value="indicator.value"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDateTime } from '@/value-objects/date-time'
import { computed } from 'vue'
import SimpleMetric from '../SimpleMetric/SimpleMetric.vue'

const { cardData } = defineProps<{
  cardData: {
    imageUrl?: string
    primaryColorHex?: string
    secondaryColorHex?: string
    description: string
    size: string
    year: number
    checked: number
    problem: number
    total: number
    productUnitCode: string
    loadedAt?: Date
  } | null
  showIndicators?: boolean
}>()

const datetime = useDateTime()
const formattedDate = computed(() =>
  cardData?.loadedAt ? datetime.format(cardData.loadedAt, 'dd/MM/yyyy, HH:mm:ss') : '-'
)

const indicators = computed(() => [
  { title: 'Apontados', value: cardData?.checked, class: 'bg-base-dark-green' },
  { title: 'Não conformes', value: cardData?.problem, class: 'bg-base-dark-red' },
  { title: 'Total da OP', value: cardData?.total, class: 'bg-secondary' }
])
</script>
